<template>
  <div style="max-width: 400px; margin: 50px auto; text-align: center;">
    <h2>Bakiye Yükle</h2>

    <div class="info-card">
      <p>
        Ödeme butonuna bastıktan sonra <strong>İş Bankası'nın güvenli ödeme sayfasına</strong> yönlendirileceksiniz.
        Kart bilgilerinizi banka ekranında girmeniz istenecektir. Kart bilgileri sistemimizde <strong>kesinlikle tutulmamaktadır</strong>.
      </p>
    </div>

    <form ref="paymentForm" :action="gatewayUrl" method="POST">
      <div class="form-group">
        <label>Tutar (₺)</label>
        <input
            v-model="amount"
            type="number"
            name="amount"
            step="0.01"
            min="0.01"
            class="form-control"
            required
        />
      </div>

      <input type="hidden" name="clientid" :value="clientid" />
      <input type="hidden" name="okurl" :value="okurl" />
      <input type="hidden" name="failUrl" :value="failUrl" />
      <input type="hidden" name="islemtipi" :value="islemtipi" />
      <input type="hidden" name="currency" :value="currency" />
      <input type="hidden" name="rnd" :value="rnd" />
      <input type="hidden" name="storetype" :value="storetype" />
      <input type="hidden" name="hashAlgorithm" :value="hashAlgorithm" />
      <input type="hidden" name="lang" :value="lang" />
      <input type="hidden" name="oid" :value="oid" />
      <input type="hidden" name="refreshtime" :value="refreshtime" />
      <input type="hidden" name="hash" :value="hash" />
      <input type="hidden" name="encoding" :value="encoding" />

      <button type="submit" class="btn btn-success mt-3" @click.prevent="submitPayment">
        Ödeme Yap
      </button>
    </form>
  </div>
</template>

<script>
import PaymentService from '../../service/PaymentService';
export default {
  name: "PaymentForm",
  data() {
    return {
      gatewayUrl: "",
      amount: "",
      clientid: '',
      okurl: "",
      failUrl: "",
      islemtipi: '',
      currency: '',
      rnd: '',
      storetype: '',
      hashAlgorithm: '',
      lang: '',
      refreshtime: '',
      encoding: "",
      oid: '',
      hash: '',
    };
  },
  methods: {
    async submitPayment() {
      if (!this.amount || isNaN(this.amount) || parseFloat(this.amount) <= 0 || !/^\d+(\.\d{1,2})?$/.test(this.amount)) {
        this.$alert(this, "Geçersiz tutar girdiniz.");
        return;
      }

      try {
        // Backend'e sadece gerekli bilgiler gönderiliyor
        const requestData = {
          amount: this.amount,
          shopId: this.$store.state.clientId
        };

        const response = await PaymentService.prepare(requestData);
        this.gatewayUrl = response.gatewayUrl;
        this.clientid = response.clientid;
        this.okurl = response.okurl;
        this.failUrl = response.failUrl;
        this.islemtipi = response.islemtipi;
        this.currency = response.currency;
        this.rnd = response.rnd;
        this.storetype = response.storetype;
        this.hashAlgorithm = response.hashAlgorithm;
        this.lang = response.lang;
        this.refreshtime = response.refreshtime;
        this.encoding = response.encoding;
        this.oid = response.oid;
        this.hash = response.hash;

        // Form backend'den gelen verilerle submit edilir
        this.$nextTick(() => {
          this.$refs.paymentForm.submit();
        });

      } catch (error) {
        console.error("Ödeme hazırlık hatası:", error);
        this.$errorNotification(this, "Ödeme hazırlığında bir hata oluştu.");
      }
    },
  },
  computed: {
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
  text-align: left;
}
input {
  width: 100%;
  padding: 8px;
  font-size: 16px;
}
button {
  padding: 10px 20px;
  font-size: 18px;
}
.info-card {
  background-color: #ffffff;
  border: 1px solid #dcdcdc;
  border-left: 5px solid #4caf50;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  text-align: left;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  font-size: 14px;
  color: #333;
}
</style>
